<template>
 <div class="admin-member">
  <div class="content-container">
   <div class="header">
    <div class="title">
        Search
        <button style="float:right;" @click="registerNewUser = true; selectedUserId = null;">Register new user</button>
    </div>
   </div>
   <div class="content">
    <div>
     <div class="member-name">Member Name</div>
     <input type="text" class="input-name" v-model="memberName" />
     <button class="search-button" @click="search">GO</button>
    </div>
    <div class="results">
     <div class="results-label">Results</div>
     <div class="results-container">
      <div
       class="result-row"
       :class="{selected: selectedUserId == user.id}"
       v-for="user in users"
       :key="user.id"
       @click="selectUser(user.id)"
      >{{user.name}} ( id: {{user.id}} )</div>
     </div>
    </div>
   </div>
  </div>
  <div class="content-container" v-if="selectedUserId">
   <div class="header">
    <div class="title">
        Detail
        <div class="go-to-profile">
          <button @click="refreshMemberCache">Refresh Cache</button>
          <button @click="goToProfile">Go to profile</button>
        </div>
    </div>
    
   </div>
   <div class="content" v-if="selectedUserDatails">
    <div class="form-content" style="margin-left:20px;">
     <h2 style="display: inline-block">Status</h2>
     <select style="margin-left: 40px; width: 150px;" name="status" v-model="userStatus">
      <option value="0">Registering</option>
      <option value="1">Registered</option>
      <option value="2">Blocked</option>
      <option value="3">Banned</option>
      <option value="4">Retired</option>
      <option value="5">Remembered</option>
     </select>
    </div>
    <div class="details-content form-content">
     <div class="details-section">
      <h2>Basic Info</h2>
      <div class="edit-row">
       <div class="caption">First Name</div>
       <input v-model="selectedUserDatails.firstName" />
      </div>
      <div class="edit-row">
       <div class="caption">Last Name</div>
       <input v-model="selectedUserDatails.lastName" />
      </div>
      <div class="edit-row">
       <div class="caption">Email</div>
       <input v-model="selectedUserDatails.email" />
      </div>
     </div>
     <div class="details-section">
      <h2>Password change</h2>
      <div class="edit-row">
       <div class="caption">New Password</div>
       <input type="password" v-model="newPassword" />
      </div>
      <div class="edit-row">
       <button class="send-to-right" @click="changePassword">Change Password</button>
       <span class="password-error send-to-right">{{passwordError}}</span>
       <span class="password-message send-to-right">{{passwordMessage}}</span>
      </div>
     </div>
     <div class="details-section">
      <h2>Location</h2>
      <div class="edit-row">
       <div class="caption">Country</div>
       <input v-model="selectedUserDatails.country" />
      </div>
      <div class="edit-row">
       <div class="caption">State/Province</div>
       <input v-model="selectedUserDatails.stateProvince" />
      </div>
      <div class="edit-row">
       <div class="caption">City</div>
       <input v-model="selectedUserDatails.city" />
      </div>
      <div class="edit-row">
       <div class="caption">Show Publicly?</div>
       <input type="checkbox" v-model="selectedUserDatails.showLocation" />
      </div>
     </div>
     <div class="details-section">
      <h2>Misc</h2>
      <div class="edit-row">
       <div class="caption">Website</div>
       <input v-model="selectedUserDatails.website" />
      </div>
      <div class="edit-row">
       <div class="caption">Interests</div>
       <input v-model="selectedUserDatails.interests" />
      </div>
      <div class="edit-row">
       <div class="caption">Avatar</div>
       <input
        style="display:none;"
        type="file"
        id="file"
        ref="file"
        v-on:change="handleFileUpload()"
       />
       <div class="send-to-right">
        <img class="send-to-right" :src="getRightAvatarUrl" alt="avatar" />
        <br />
        <button @click="changeAvatar">Change Avatar</button>
        <div>{{newAvatarName}}</div>
       </div>
      </div>
     </div>
     <div class="details-section">
         <h2>Admin</h2>
         <div class="edit-row">
          <div class="caption">Custom Title</div>
          <input v-model="selectedUserDatails.customTitle" />
         </div>
         <div class="edit-row">
          <div class="caption">Post Offset</div>
          <input type="number" min="0" step="1" pattern="\d*"  v-model="selectedUserDatails.postOffset" />
         </div>
         <div class="edit-row">
            <div class="caption">Role</div>
            <select style="margin-left: 40px; width: 150px;" name="status" v-model="selectedUserDatails.forumRole">
             <option value="1">Member</option>
             <option value="2">VIP</option>
             <option value="3">Editor</option>
             <option value="4">Moderator</option>
             <option value="5">Administrator</option>
             <option v-if="isCurrentMemberCoreAdmin" value="6">Core Administrator</option>
            </select>
         </div>
         <div class="edit-row">
            <div class="send-to-right">
             <button @click="resetLogin">Reset Consecutive Failed Login Attempts</button>
            </div>
         </div>
     </div>
    </div>
   </div>
   <div class="footer">
       <div class="footer-right">
           <button v-on:click="submitDetails">Submit</button>
       </div>
   </div>
  <EditBio v-if="isMounted" :bioInfo="bioInfo" />
  <EditSignature v-if="isMounted" :signatureInfo="signatureInfo" />
  <EditForumSettings v-if="isMounted" :settings="forumSettings"  :memberId="selectedUserId"/>
  </div>
  <register  v-if="registerNewUser"/>
 </div>
</template>

<script>
import api from "../../api/api";
import EditBio from "../Member/EditBio";
import EditSignature from "../Member/EditSignature";
import EditForumSettings from "../Member/EditSettings";
import Register from "../../views/auth/Register.vue";
import dialogs from '../../modules/dialogs'

const settingKeys = {
    DATE_FORMAT: 1,
    TIME_FORMAT: 2,
    POST_FORMAT: 4,
    POST_ORDER: 5,
    POSTS_PER_PAGE: 6,
    TOPICS_PER_PAGE: 7,
    USE_MESSAGING: 8,
    USE_EMOTICONS: 9,
    VIEW_SIGNATURES: 10,
    VIEW_AVATARS: 11
}

const getSetting = function(key, forumSettings) {
            if (key === settingKeys.DATE_FORMAT) return forumSettings.find(x => x.settingID === key).settingValue;
            if (key === settingKeys.TIME_FORMAT) return forumSettings.find(x => x.settingID === key).settingValue;
            if (key === settingKeys.POST_ORDER) return forumSettings.find(x => x.settingID === key).settingValue;
            if (key === settingKeys.POSTS_PER_PAGE) return parseInt(forumSettings.find(x => x.settingID === key).settingValue);
            if (key === settingKeys.POST_FORMAT) return forumSettings.find(x => x.settingID === key).settingValue;
            if (key === settingKeys.TOPICS_PER_PAGE) return parseInt(forumSettings.find(x => x.settingID === key).settingValue);
            if (key === settingKeys.USE_EMOTICONS) return forumSettings.find(x => x.settingID === key).settingValue === 'true';
            if (key === settingKeys.USE_MESSAGING) return forumSettings.find(x => x.settingID === key).settingValue === 'true';
            if (key === settingKeys.VIEW_AVATARS) return forumSettings.find(x => x.settingID === key).settingValue === 'true';
            if (key === settingKeys.VIEW_SIGNATURES) return forumSettings.find(x => x.settingID === key).settingValue === 'true';
            return null;
        };

const getDateFormat = (fSettings) => { return getSetting(settingKeys.DATE_FORMAT, fSettings) };
const getTimeFormat =  (fSettings) => { return getSetting(settingKeys.TIME_FORMAT, fSettings) };
const getPostFormat = (fSettings) => { return getSetting(settingKeys.POST_FORMAT, fSettings) };
const getPostOrder = (fSettings) => { return getSetting(settingKeys.POST_ORDER, fSettings) };
const getPostsPerPage = (fSettings) => { return getSetting(settingKeys.POSTS_PER_PAGE, fSettings) };
const getTopicsPerPage = (fSettings) => { return getSetting(settingKeys.TOPICS_PER_PAGE, fSettings) };
const getUseMessaging = (fSettings) => { return getSetting(settingKeys.USE_MESSAGING, fSettings) };
const getUseEmoticons = (fSettings) => { return getSetting(settingKeys.USE_EMOTICONS, fSettings) };
const getViewSignatures = (fSettings) => { return getSetting(settingKeys.VIEW_SIGNATURES, fSettings) };
const getViewAvatars = (fSettings) => { return getSetting(settingKeys.VIEW_SIGNATURES, fSettings) };


export default {
  components: {
    EditBio,
    EditSignature,
    EditForumSettings,
    Register
  },
 data() {
  return {
   registerNewUser: false,
   memberName: "",
   users: [],
   selectedUserId: null,
   selectedUserDatails: {
     avatarUrl: null,
     customTitle: null,
     postOffset: null,
   },
   currentPassword: null,
   newPassword: null,
   confirmNewPassword: null,
   passwordError: null,
   passwordMessage: null,
   avatar: null,
   userStatus: null,
   bioInfo: {},
   signatureInfo: {},
   isMounted: false,
   forumSettings: {},
   forumData: null
  };
 },
 computed: {
   isCurrentMemberCoreAdmin: function() {
     return this.$store.getters.user.isCoreAdmin();
   },
  newAvatarName() {
   if (!this.avatar) {
    return null;
   }
   return this.avatar.name;
  },
  getRightAvatarUrl() {
    return this.selectedUserDatails.avatarUrl + '?' + new Date().toISOString();
  },
 },
 watch: {
  selectedUserId(newValue) {
    this.refreshUser(newValue);
  },
 },
 methods: {
     goToProfile() {
         this.$router.push('/members/' + this.selectedUserId);
     },
     refreshMemberCache: function () {
       api.post('/members/' + this.selectedUserId + '/refreshCache')
        .then(async () => {
          await dialogs.alertAsync('Member cache updated');
        });
     },
  refreshUser(newValue) {
    this.selectedUserDatails = null;
    this.currentPassword = null;
    this.newPassword = null;
    this.confirmNewPassword = null;
    this.passwordError = null;
    this.passwordMessage = null;
    this.avatar = null;
    this.userStatus = null;
    this.bioInfo = null;
    this.bioInfo = {};
    this.signatureInfo= null;
    this.signatureInfo= {};
    this.isMounted =false;
    this.forumSettings= null;
    this.forumSettings= {};
    this.forumData= null;


    api.get("/members/" + newValue + "/editAdmin").then((r) => {
     this.selectedUserDatails = r.data;
     this.userStatus = r.data.status;
     this.bioInfo.id = this.selectedUserId
     this.bioInfo.bio = r.data.bio;


     this.signatureInfo.id = this.selectedUserId;
     this.signatureInfo.signature = r.data.signature;

     api.auth('/getUserData/'+this.selectedUserId).then((aR) => {
       this.forumData = aR.data.user.settings;
       this.forumSettings.dateFormat = getDateFormat(this.forumData);
       this.forumSettings.timeFormat = getTimeFormat(this.forumData);
       this.forumSettings.postFormat = getPostFormat(this.forumData);
       this.forumSettings.postOrder = getPostOrder(this.forumData);
       this.forumSettings.postsPerPage = getPostsPerPage(this.forumData);
       this.forumSettings.topicsPerPage = getTopicsPerPage(this.forumData);
       this.forumSettings.useMessaging = getUseMessaging(this.forumData);
       this.forumSettings.useEmoticons = getUseEmoticons(this.forumData);
       this.forumSettings.viewSignatures = getViewSignatures(this.forumData);
       this.forumSettings.viewAvatars = getViewAvatars(this.forumData);
       this.isMounted = true;
     });
    });
  },
  changeAvatar() {
   this.$refs.file.click();
  },
  handleFileUpload() {
   this.avatar = this.$refs.file.files[0];
  },
  selectUser(userId) {
   this.selectedUserId = userId;
   this.registerNewUser = false;
  },
  search() {
      this.registerNewUser = false;
   if (this.memberName) {
    api
     .get("/members/messageOptions", {
      params: {
       name: this.memberName,
      },
     })
     .then((r) => {
      this.users = r.data;
     });
   }
   if (this.memberName == "") {
    this.users = [];
    this.selectedUserId = null;
   }
  },
  changePassword() {
    this.passwordError = "";
    this.passwordMessage = "";
    api.auth('/changePasswordAdmin/' + this.selectedUserId, {
      NewPassword: this.newPassword
    }).then(() => {
      this.currentPassword = "";
      this.newPassword = ""
      this.confirmNewPassword = "";
      this.passwordMessage = "Success";
    }).catch((error) => {
      this.currentPassword = "";
      this.newPassword = ""
      this.confirmNewPassword = "";
      this.passwordError = error.response.data.message;
    })
  },
  resetLogin() {
      api.post('/members/' + this.selectedUserId + '/resetLogin')
            .then(async () => {
                await dialogs.alertAsync('Login attempts reset to 0');
            }
        ).catch(async (error) => {
            await dialogs.alertAsync(error);
        });
  },
  submitDetails() {
      let data = {};
      data.memberID = this.selectedUserId;
      data.firstName = this.selectedUserDatails.firstName
      data.lastName = this.selectedUserDatails.lastName
      data.email = this.selectedUserDatails.email
      data.country = this.selectedUserDatails.country
      data.stateProvince = this.selectedUserDatails.stateProvince
      data.city = this.selectedUserDatails.city
      data.showLocation = this.selectedUserDatails.showLocation
      data.website = this.selectedUserDatails.website
      data.interests = this.selectedUserDatails.interests;
      data.userStatus = parseInt(this.userStatus);
      data.customTitle = this.selectedUserDatails.customTitle;
      data.forumRole = parseInt(this.selectedUserDatails.forumRole);
      api.post('/members/' + this.selectedUserId + '/admin', data)
          .then(async (response) => {
              if (response.data.success === true ) {
                  if(this.avatar) {
                    var formData = new FormData();
                    var imagefile = this.avatar;
                    formData.append("image", imagefile);
                    await api.post('/members/changeAvatar/'+ this.selectedUserId,formData ,{
                        headers: {
                          'Content-Type': 'multipart/form-data'
                        }});
                    this.refreshUser(this.selectedUserId);
                  }
                  await dialogs.alertAsync("Member Settings Saved");
              } else {
                  await dialogs.alertAsync(response.data.message);
              }
          }
      ).catch(async (error) => {
          await dialogs.alertAsync(error);
      });
  },
 },
};
</script>

<style scoped>

</style>